import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class AppService {

  constructor(
    private swUpdate: SwUpdate,
    private toastController: ToastController,
  ) { }

  checkForUpdates() {
    this.swUpdate.versionUpdates.subscribe(async e => {

    if (e.type === 'VERSION_READY') {
      const toast = await this.toastController.create({
        message: 'New version is available. Please reload the page',
        buttons: [
          {
            text: 'Dismiss',
            role: 'cancel'
          }
        ],
        cssClass: 'button-toast'
      })

        await toast.present();
      }
    })
  }

}
